import { Badge } from "@/components/ui/badge";
import { LeaderboardRow } from "@/components/LeaderboardRow";

export const FeaturedShelf = ({ listings, onClaim, onRaise }) => {
    const rows = (listings || []).slice(0, 3);
    if (!rows.length) return null;
    return (
        <div className="mb-8" data-testid="featured-shelf">
            <div className="flex items-center justify-between mb-3">
                <h2 className="font-heading text-lg font-bold flex items-center gap-2">
                    Featured
                    <Badge variant="secondary" className="text-[10px] uppercase tracking-wide">
                        Paid placement
                    </Badge>
                </h2>
                <span className="text-xs text-muted-foreground">Not ranked by likes</span>
            </div>
            <div className="space-y-3">
                {rows.map((row) => (
                    <LeaderboardRow
                        key={row.id}
                        row={row}
                        featured={row.rank === 1}
                        onClaim={onClaim}
                        onRaise={onRaise}
                    />
                ))}
            </div>
        </div>
    );
};
